export default __webpack_public_path__ + "static/matthijs-crietee-300x300-266x266-8c167b887d8543fcc9dd9c0b16c52ddb.jpg";